'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _baseUtils = require('../utils/baseUtils');

var _windowWrapper = require('../sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GallerySettings = function () {
  function GallerySettings() {
    var _this = this;

    (0, _classCallCheck3.default)(this, GallerySettings);

    try {
      this.protocol = _windowWrapper2.default.location.protocol;
      this.galleryId = _windowWrapper2.default.galleryId;
      this.instance = _windowWrapper2.default.instance;
    } catch (e) {
      this.protocol = 'http:';
      this.galleryId = '';
      this.instance = '';
    }
    this.baseUrl = this.protocol + '//progallery.wix.com/_api/pro-gallery-editor-webapp/v1/gallery/';
    this.getGallerySettingsApi = function () {
      return '' + _this.baseUrl + _this.galleryId + '?instance=' + _this.instance + '&isStore=' + _baseUtils.baseUtils.isStoreGallery();
    };
  }

  (0, _createClass3.default)(GallerySettings, [{
    key: 'get',
    value: function get(key) {
      return _axios2.default.get(this.getGallerySettingsApi(), { withCredentials: true, xsrfCookieName: null }).then(function (_ref) {
        var data = _ref.data;

        return key ? data.settings[key] : data.settings;
      });
    }
  }, {
    key: 'set',
    value: function set(key, value) {
      var _this2 = this;

      return this.get().then(function (data) {
        data = data || {};
        var settings = (0, _assign2.default)(data, (0, _defineProperty3.default)({}, key, value));
        return _axios2.default.put(_this2.getGallerySettingsApi(), { settings: settings }, { withCredentials: true, xsrfCookieName: null }).then(function () {
          return _baseUtils.baseUtils.setExternalId();
        });
      });
    }
  }]);
  return GallerySettings;
}();

var gallerySettings = new GallerySettings();
exports.default = gallerySettings;